export const FACTORY_ADDRESS = '0x475f361993D6FAcBF32fB82B66be0fB40f3d974C'
export const INIT_CODE_HASH = '0xa0906c48ef10b3fc231e49802ad030f5467c3cd8e3811f34e7091c74d149e6ab'
